import script from "./SattingAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./SattingAdmin.vue?vue&type=script&setup=true&lang=js"

import "./SattingAdmin.vue?vue&type=style&index=0&id=cd912dbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd912dbc"]])

export default __exports__